export default __webpack_public_path__ + "static/media/Glodani 11.7cbba145.jpg";